import React, { Component } from 'react';
import styled from 'styled-components';
import NoteFilters from '../../../../components/FiltersFields';
import { I18n } from 'react-redux-i18n';

const Container = styled.div`
  background-color: rgba(245, 245, 245, 0.5);
  padding: 27px 21px 20px 20px;
  border-radius: 4px;
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : '0px'};

  .searchWineContainer {
    margin-top: 20px;
  }
`;

class FilterBloc extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      type,
      vintage,
      color,
      appellation,
      rank,
      options,
      onChange,
      onChangeType,
      onChangeVintage
    } = this.props;

    return (
      <Container marginBottom={this.props.marginBottom}>
        <NoteFilters
          typeFilter={{
            selectedOption: type,
            options: options.type,
            isClearable: false,
            onChange: (selectedOption) => onChangeType(selectedOption),
            label: I18n.t('notes.wxr.filters.type'),
            placeholder: I18n.t('placeholderAll')
          }}
          vintagesFilter={{
            selectedOption: vintage,
            options: options.vintage.sort(function (a, b) {
              return b.value - a.value;
            }),
            isClearable: false,
            onChange: (selectedOption) => onChangeVintage(selectedOption),
            label: I18n.t('notes.wxr.filters.vintage'),
            placeholder: I18n.t('placeholderAll')
          }}
          colorFilter={{
            selectedOption: color,
            options: options.color,
            onChange: (selectedOption) => onChange('color', selectedOption),
            label: I18n.t('notes.wxr.filters.color'),
            placeholder: I18n.t('placeholderAll2')
          }}
          appellationFilter={{
            selectedOption: appellation,
            options: options.appellation,
            onChange: (selectedOption) =>
              onChange('appellation', selectedOption),
            label: I18n.t('notes.wxr.filters.appellation'),
            placeholder: I18n.t('placeholderAll2')
          }}
          rankFilter={{
            selectedOption: rank,
            options: options.rank,
            onChange: (selectedOption) => onChange('rank', selectedOption),
            label: I18n.t('notes.wxr.filters.rank'),
            placeholder: I18n.t('placeholderAll')
          }}
        />
      </Container>
    );
  }
}

export default FilterBloc;
